module.exports = "/assets/33da666db7873a1e6bb943819fd341a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/LT.png
// module id = 2715
// module chunks = 0